// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Header_navLink_3PMn9","spinAround":"Header_spinAround_13Oqa"};